import React from 'react';
import './Modal.css';

const Modal = ({ open, setOpen }) => {
	return <React.Fragment>
		{open && <div id="myModal" className="modal" onClick={() => setOpen(false)}>
		  <div className="modal-content" onClick={evt => evt.stopPropagation()} >
		  	<div className="closebtn" onClick={() => setOpen(false)}>&times;</div>
		  	<img src={open}/>
		  </div>
		</div>}
	</React.Fragment>
}


export default Modal;
